import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Card, Col, Nav, Row, Badge, Spinner, Alert, Modal, Form, Button, ProgressBar, Tab, Tabs } from "react-bootstrap";
import Footer from "../layouts/Footer";
import HeaderMobile from "../layouts/HeaderMobile";
import Header from "../layouts/Header";
import { formatDate } from "../utils/formatters";

// Import d'avatars par défaut
import img1 from "../assets/img/img1.jpg";
import img5 from "../assets/img/img5.jpg";
import img6 from "../assets/img/img6.jpg";
import img7 from "../assets/img/img7.jpg";
import img8 from "../assets/img/img8.jpg";
import img9 from "../assets/img/img9.jpg";
import img10 from "../assets/img/img10.jpg";
import img11 from "../assets/img/img11.jpg";
import img12 from "../assets/img/img12.jpg";

// Styles supplémentaires
const styles = `
  .profile-avatar-large {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
    font-weight: bold;
    border: 4px solid white;
    box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
    transition: all 0.3s ease;
  }

  .profile-avatar-large:hover {
    transform: scale(1.05);
    box-shadow: 0 15px 40px rgba(102, 126, 234, 0.4);
  }

  .profile-avatar-small {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: bold;
  }

  .profile-stats-card {
    background: linear-gradient(135deg, #667eea10 0%, #764ba210 100%);
    border: none;
    border-radius: 20px;
    padding: 25px;
    text-align: center;
    transition: all 0.3s ease;
    cursor: pointer;
  }

  .profile-stats-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(102, 126, 234, 0.2);
  }

  .profile-stats-number {
    font-size: 36px;
    font-weight: 700;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin-bottom: 5px;
  }

  .profile-stats-label {
    color: #6c757d;
    font-size: 14px;
    font-weight: 500;
  }

  .profile-timeline-custom {
    position: relative;
    padding-left: 30px;
  }

  .profile-timeline-custom::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 2px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }

  .profile-timeline-item-custom {
    position: relative;
    padding-bottom: 20px;
  }

  .profile-timeline-item-custom::before {
    content: '';
    position: absolute;
    left: -34px;
    top: 0;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #667eea;
    border: 2px solid white;
  }

  .activity-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }

  .badge-gradient {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 8px 16px;
    border-radius: 30px;
    font-weight: 600;
  }

  .info-card {
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border: none;
    border-radius: 15px;
    padding: 20px;
    margin-bottom: 15px;
    transition: all 0.3s ease;
  }

  .info-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(0,0,0,0.1);
  }

  .nav-pills-custom .nav-link {
    border: none;
    padding: 12px 20px;
    font-weight: 600;
    color: #6c757d;
    transition: all 0.3s ease;
    border-radius: 12px;
    margin: 0 5px;
  }

  .nav-pills-custom .nav-link:hover {
    color: #667eea;
    background: rgba(102, 126, 234, 0.1);
  }

  .nav-pills-custom .nav-link.active {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white !important;
    box-shadow: 0 5px 15px rgba(102, 126, 234, 0.3);
  }
`;

export default function Profile() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [stats, setStats] = useState(null);
  const [activeTab, setActiveTab] = useState("info");
  const [activityScore, setActivityScore] = useState(85);
  
  // États pour les modals
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [show2FAModal, setShow2FAModal] = useState(false);
  const [showSuccessAlert, setShowSuccessAlert] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  
  // États pour les activités
  const [activites, setActivites] = useState([]);
  const [connexions, setConnexions] = useState([]);
  const [loadingActivites, setLoadingActivites] = useState(false);
  
  // États pour les formulaires
  const [editForm, setEditForm] = useState({
    nom_utilisateur: "",
    prenom_utilisateur: "",
    email: ""
  });
  
  const [passwordForm, setPasswordForm] = useState({
    ancien_mdp: "",
    nouveau_mdp: "",
    confirmation: ""
  });
  
  // États pour 2FA
  const [twoFAEnabled, setTwoFAEnabled] = useState(false);
  const [twoFAPassword, setTwoFAPassword] = useState("");
  const [twoFALoading, setTwoFALoading] = useState(false);
  
  const [saving, setSaving] = useState(false);
  const [formError, setFormError] = useState("");

  useEffect(() => {
    fetchProfile();
  }, []);

  useEffect(() => {
    if (user) {
      setEditForm({
        nom_utilisateur: user.nom_utilisateur || "",
        prenom_utilisateur: user.prenom_utilisateur || "",
        email: user.email || ""
      });
    }
  }, [user]);

  const getCurrentUser = () => {
    try {
      const userStr = localStorage.getItem("user");
      if (userStr && userStr !== "undefined" && userStr !== "null") {
        return JSON.parse(userStr);
      }
    } catch (error) {
      console.error("Erreur parsing utilisateur:", error);
      localStorage.removeItem("user");
    }
    return null;
  };

  const fetchActivites = async () => {
    try {
      setLoadingActivites(true);
      const currentUser = getCurrentUser();
      const userId = currentUser.id_utilisateur || currentUser.id;
      
      const response = await fetch(
        `https://sawd.julesferry-ga.com/api/activites.php?action=historique&user_id=${userId}&limite=20`,
        { headers: { 'Content-Type': 'application/json' } }
      );
      
      const result = await response.json();
      if (result.success) setActivites(result.data);
    } catch (err) {
      console.error("Erreur chargement activités:", err);
    } finally {
      setLoadingActivites(false);
    }
  };

  const fetchConnexions = async () => {
    try {
      const currentUser = getCurrentUser();
      const userId = currentUser.id_utilisateur || currentUser.id;
      
      const response = await fetch(
        `https://sawd.julesferry-ga.com/api/activites.php?action=connexions&user_id=${userId}&limite=5`,
        { headers: { 'Content-Type': 'application/json' } }
      );
      
      const result = await response.json();
      if (result.success) setConnexions(result.data);
    } catch (err) {
      console.error("Erreur chargement connexions:", err);
    }
  };

  const fetchProfile = async () => {
    try {
      setLoading(true);
      const currentUser = getCurrentUser();
      
      if (!currentUser) {
        navigate('/pages/signin2');
        return;
      }

      const userId = currentUser.id_utilisateur || currentUser.id;
      
      const response = await fetch(
        `https://sawd.julesferry-ga.com/api/utilisateurs.php?action=profil&user_id=${userId}`,
        { headers: { 'Content-Type': 'application/json' } }
      );
      
      const result = await response.json();
      
      if (result.success) {
        setUser(result.data);
        setStats(result.data.stats);
        if (result.data.two_factor_enabled !== undefined) {
          setTwoFAEnabled(result.data.two_factor_enabled == 1);
        }
        if (result.data.stats) {
          const total = (result.data.stats.factures || 0) + (result.data.stats.devis || 0);
          setActivityScore(Math.min(100, Math.round((total / 50) * 100)));
        }
        await fetchActivites();
        await fetchConnexions();
      } else {
        setError(result.message);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const getRelativeTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffSec = Math.floor(diffMs / 1000);
    const diffMin = Math.floor(diffSec / 60);
    const diffHour = Math.floor(diffMin / 60);
    const diffDay = Math.floor(diffHour / 24);
    
    if (diffSec < 60) return "À l'instant";
    if (diffMin < 60) return `Il y a ${diffMin} min`;
    if (diffHour < 24) return `Il y a ${diffHour}h`;
    if (diffDay < 7) return `Il y a ${diffDay}j`;
    return formatDate(dateString);
  };

  const getActivityIcon = (type) => {
    const icons = {
      'facture': 'ri-file-list-line',
      'devis': 'ri-file-copy-line',
      'commande': 'ri-shopping-cart-line',
      'reglement': 'ri-bank-card-line',
      'stock': 'ri-stack-line',
      'inventaire': 'ri-file-list-3-line',
      'bl': 'ri-truck-line',
      'connexion': 'ri-login-circle-line'
    };
    return icons[type] || 'ri-history-line';
  };

  const getActivityColor = (type) => {
    const colors = {
      'facture': '#10b981',
      'devis': '#f59e0b',
      'commande': '#3b82f6',
      'reglement': '#8b5cf6',
      'stock': '#6b7280',
      'inventaire': '#ec4899',
      'bl': '#f97316',
      'connexion': '#3b82f6'
    };
    return colors[type] || '#6c757d';
  };

  const getActivityLabel = (type) => {
    const labels = {
      'facture': 'Facture',
      'devis': 'Devis',
      'commande': 'Commande',
      'reglement': 'Règlement',
      'stock': 'Stock',
      'inventaire': 'Inventaire',
      'bl': 'BL',
      'connexion': 'Connexion'
    };
    return labels[type] || type;
  };

  const handleUpdateProfile = async () => {
    setSaving(true);
    setFormError("");
    try {
      const currentUser = getCurrentUser();
      const userId = currentUser.id_utilisateur || currentUser.id;
      
      const response = await fetch(
        `https://sawd.julesferry-ga.com/api/update_profil.php?user_id=${userId}`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(editForm)
        }
      );
      
      const result = await response.json();
      
      if (result.success) {
        setShowSuccessAlert(true);
        setSuccessMessage("Profil mis à jour avec succès");
        const updatedUser = { ...currentUser, ...editForm };
        localStorage.setItem("user", JSON.stringify(updatedUser));
        await fetchProfile();
        setShowEditModal(false);
        setTimeout(() => setShowSuccessAlert(false), 3000);
      } else {
        setFormError(result.message);
      }
    } catch (err) {
      setFormError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleChangePassword = async () => {
    if (passwordForm.nouveau_mdp !== passwordForm.confirmation) {
      setFormError("Les mots de passe ne correspondent pas");
      return;
    }
    setSaving(true);
    setFormError("");
    try {
      const currentUser = getCurrentUser();
      const userId = currentUser.id_utilisateur || currentUser.id;
      
      const response = await fetch(
        `https://sawd.julesferry-ga.com/api/change_password.php?user_id=${userId}`,
        {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            ancien_mdp: passwordForm.ancien_mdp,
            nouveau_mdp: passwordForm.nouveau_mdp
          })
        }
      );
      
      const result = await response.json();
      
      if (result.success) {
        setShowSuccessAlert(true);
        setSuccessMessage("Mot de passe modifié avec succès");
        setPasswordForm({ ancien_mdp: "", nouveau_mdp: "", confirmation: "" });
        setShowPasswordModal(false);
        setTimeout(() => setShowSuccessAlert(false), 3000);
      } else {
        setFormError(result.message);
      }
    } catch (err) {
      setFormError(err.message);
    } finally {
      setSaving(false);
    }
  };

  const handleToggle2FA = async () => {
    setTwoFALoading(true);
    setFormError("");
    try {
      const currentUser = getCurrentUser();
      const userId = currentUser.id_utilisateur || currentUser.id;
      
      const response = await fetch(
        `https://sawd.julesferry-ga.com/api/toggle_2fa.php?user_id=${userId}`,
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            password: twoFAPassword,
            enabled: !twoFAEnabled
          })
        }
      );
      
      const result = await response.json();
      
      if (result.success) {
        setTwoFAEnabled(!twoFAEnabled);
        await fetchProfile();
        setShowSuccessAlert(true);
        setSuccessMessage(twoFAEnabled ? "2FA désactivée" : "2FA activée avec succès");
        setShow2FAModal(false);
        setTwoFAPassword("");
        setTimeout(() => setShowSuccessAlert(false), 3000);
      } else {
        setFormError(result.message);
      }
    } catch (err) {
      setFormError(err.message);
    } finally {
      setTwoFALoading(false);
    }
  };

  const getRoleBadge = (role) => {
    const badges = {
      admin: { color: 'danger', label: 'Administrateur', gradient: 'linear-gradient(135deg, #f43f5e 0%, #e11d48 100%)' },
      gestionnaire: { color: 'warning', label: 'Gestionnaire', gradient: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' },
      commercial: { color: 'info', label: 'Commercial', gradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)' },
      magasinier: { color: 'success', label: 'Magasinier', gradient: 'linear-gradient(135deg, #10b981 0%, #059669 100%)' }
    };
    const badge = badges[role] || { label: role, gradient: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)' };
    return (
      <span className="badge-gradient" style={{ background: badge.gradient }}>
        {badge.label}
      </span>
    );
  };

  const getUserInitials = () => {
    if (!user) return '';
    const prenom = user.prenom_utilisateur || user.prenom || '';
    const nom = user.nom_utilisateur || user.nom || '';
    return `${prenom.charAt(0) || ''}${nom.charAt(0) || ''}`.toUpperCase() || 'U';
  };

  const getUserFullName = () => {
    if (!user) return 'Utilisateur';
    const prenom = user.prenom_utilisateur || user.prenom || '';
    const nom = user.nom_utilisateur || user.nom || '';
    return (prenom + ' ' + nom).trim() || 'Utilisateur';
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="text-center">
          <div className="spinner-grow text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
            <span className="visually-hidden">Chargement...</span>
          </div>
          <p className="mt-3 text-muted">Chargement de votre profil...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Alert variant="danger" className="text-center border-0 shadow-lg p-5" style={{ borderRadius: '20px' }}>
          <i className="ri-error-warning-line fs-1 mb-3 d-block text-danger"></i>
          <h4>{error}</h4>
          <Button variant="danger" className="mt-3 px-5" onClick={() => navigate('/pages/signin2')}>
            Retour à la connexion
          </Button>
        </Alert>
      </div>
    );
  }

  return (
    <React.Fragment>
      <style>{styles}</style>
       <Header />
      <div className="main main-app p-4 p-lg-5">
        <div className="container-fluid">
          {/* Alertes de succès */}
          {showSuccessAlert && (
            <Alert variant="success" className="animate__animated animate__fadeInUp mb-4" style={{ borderRadius: '15px' }} onClose={() => setShowSuccessAlert(false)} dismissible>
              <i className="ri-checkbox-circle-line me-2"></i>
              {successMessage}
            </Alert>
          )}

          <Row className="g-5">
            {/* Colonne principale */}
            <Col xl>
              {/* En-tête du profil */}
              <div className="d-flex flex-column flex-sm-row align-items-center gap-4 mb-5 p-4" style={{ background: 'linear-gradient(135deg, #667eea10 0%, #764ba210 100%)', borderRadius: '30px' }}>
                <div className="profile-avatar-large">
                  {getUserInitials()}
                </div>
                <div className="flex-grow-1 text-center text-sm-start">
                  <div className="d-flex flex-wrap align-items-center gap-3 mb-2">
                    <h2 className="fw-bold mb-0">{getUserFullName()}</h2>
                    {getRoleBadge(user?.role)}
                  </div>
                  <p className="text-muted mb-2">
                    <i className="ri-mail-line me-2"></i>
                    {user?.email}
                  </p>
                  <p className="text-muted mb-3">
                    <i className="ri-calendar-line me-2"></i>
                    Membre depuis {formatDate(user?.date_creation)}
                  </p>
                  <Button 
                    variant="primary" 
                    className="px-4 py-2"
                    style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', border: 'none' }}
                    onClick={() => setShowEditModal(true)}
                  >
                    <i className="ri-edit-line me-2"></i>
                    Modifier le profil
                  </Button>
                </div>
              </div>

              {/* Cartes de statistiques */}
              {/* <Row className="g-4 mb-5">
                {[
                  { icon: 'ri-file-list-line', number: stats?.factures || 0, label: 'Factures' },
                  { icon: 'ri-file-copy-line', number: stats?.devis || 0, label: 'Devis' },
                  { icon: 'ri-stack-line', number: activityScore, label: 'Score', suffix: '%' },
                  { icon: 'ri-shield-line', number: twoFAEnabled ? 'Activé' : 'Désactivé', label: '2FA', isBadge: true }
                ].map((stat, index) => (
                  <Col sm={6} lg={3} key={index}>
                    <div className="profile-stats-card">
                      <i className={`${stat.icon} fs-1 mb-3`} style={{ color: '#667eea' }}></i>
                      {stat.isBadge ? (
                        <Badge bg={stat.number === 'Activé' ? 'success' : 'secondary'} className="px-3 py-2 mb-2">
                          {stat.number}
                        </Badge>
                      ) : (
                        <div className="profile-stats-number">{stat.number}{stat.suffix || ''}</div>
                      )}
                      <div className="profile-stats-label">{stat.label}</div>
                    </div>
                  </Col>
                ))}
              </Row> */}

              {/* Barre de progression d'activité */}
              <div className="mb-5 p-4" style={{ background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)', borderRadius: '20px' }}>
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <h6 className="fw-semibold mb-0">Niveau d'activité</h6>
                  <span className="text-primary fw-bold">{activityScore}%</span>
                </div>
                <ProgressBar 
                  now={activityScore} 
                  variant="primary" 
                  style={{ height: '10px', borderRadius: '5px' }}
                />
              </div>

              {/* Navigation par onglets */}
              <Nav variant="pills" className="nav-pills-custom mb-4 flex-wrap">
                <Nav.Link 
                  className={activeTab === 'info' ? 'active' : ''} 
                  onClick={() => setActiveTab('info')}
                >
                  <i className="ri-information-line me-2"></i>
                  Informations
                </Nav.Link>
                <Nav.Link 
                  className={activeTab === 'securite' ? 'active' : ''} 
                  onClick={() => setActiveTab('securite')}
                >
                  <i className="ri-lock-line me-2"></i>
                  Sécurité
                </Nav.Link>
                <Nav.Link 
                  className={activeTab === 'activite' ? 'active' : ''} 
                  onClick={() => setActiveTab('activite')}
                >
                  <i className="ri-history-line me-2"></i>
                  Activité
                </Nav.Link>
              </Nav>

              {/* Contenu des onglets */}
              <div className="mt-4">
                {activeTab === 'info' && (
                  <div>
                    <h5 className="fw-bold mb-4">Informations personnelles</h5>
                    <Row>
                      <Col md={6}>
                        <div className="info-card">
                          <small className="text-muted d-block mb-1">Nom</small>
                          <p className="fw-bold fs-5 mb-0">{user?.nom_utilisateur}</p>
                        </div>
                      </Col>
                      <Col md={6}>
                        <div className="info-card">
                          <small className="text-muted d-block mb-1">Prénom</small>
                          <p className="fw-bold fs-5 mb-0">{user?.prenom_utilisateur}</p>
                        </div>
                      </Col>
                      <Col md={12}>
                        <div className="info-card">
                          <small className="text-muted d-block mb-1">Email</small>
                          <p className="fw-bold fs-5 mb-0">{user?.email}</p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                )}

                {activeTab === 'securite' && (
                  <div>
                    <h5 className="fw-bold mb-4">Sécurité du compte</h5>
                    
                    <div className="info-card d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="fw-semibold mb-1">Mot de passe</h6>
                        <p className="text-muted mb-0">••••••••</p>
                      </div>
                      <Button variant="link" className="text-primary p-0" onClick={() => setShowPasswordModal(true)}>
                        Changer
                      </Button>
                    </div>

                    <div className="info-card d-flex justify-content-between align-items-center">
                      <div>
                        <h6 className="fw-semibold mb-1">Authentification à deux facteurs</h6>
                        <Badge bg={twoFAEnabled ? "success" : "secondary"} className="mt-1">
                          {twoFAEnabled ? "Activé" : "Désactivé"}
                        </Badge>
                      </div>
                      <Button variant="link" className="text-primary p-0" onClick={() => setShow2FAModal(true)}>
                        {twoFAEnabled ? "Désactiver" : "Activer"}
                      </Button>
                    </div>

                    <div className="info-card">
                      <h6 className="fw-semibold mb-3">Dernières connexions</h6>
                      {connexions.slice(0, 2).map((conn, index) => (
                        <div key={index} className="d-flex justify-content-between align-items-center mb-2 pb-2 border-bottom">
                          <div>
                            <i className="ri-map-pin-line me-2 text-primary"></i>
                            <span>{conn.ip || 'IP inconnue'}</span>
                          </div>
                          <small className="text-muted">{getRelativeTime(conn.date_creation)}</small>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {activeTab === 'activite' && (
                  <div>
                    <h5 className="fw-bold mb-4">Historique d'activité</h5>
                    
                    {loadingActivites ? (
                      <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-3 text-muted">Chargement des activités...</p>
                      </div>
                    ) : activites.length > 0 ? (
                      <div className="profile-timeline-custom" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        {activites.map((activite, index) => (
                          <div key={index} className="profile-timeline-item-custom">
                            <div className="d-flex gap-3">
                              <div className="activity-icon" style={{ backgroundColor: getActivityColor(activite.type) + '20', color: getActivityColor(activite.type) }}>
                                <i className={getActivityIcon(activite.type)}></i>
                              </div>
                              <div className="flex-grow-1">
                                <div className="d-flex justify-content-between align-items-start">
                                  <div>
                                    <p className="fw-semibold mb-1">{activite.description}</p>
                                    <Badge bg="light" text="dark" className="px-3 py-1">
                                      {getActivityLabel(activite.type)}
                                    </Badge>
                                  </div>
                                  <small className="text-muted">{getRelativeTime(activite.date_activite)}</small>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-5">
                        <i className="ri-history-line fs-1 text-muted mb-3"></i>
                        <p className="text-muted">Aucune activité récente</p>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </Col>

            {/* Colonne latérale */}
            <Col xl="4" className="d-none d-xl-block">
              <h5 className="section-title mb-4">Dernières connexions</h5>
              <div className="list-group mb-5">
                {connexions.length > 0 ? (
                  connexions.map((conn, index) => (
                    <div key={index} className="list-group-item border-0 bg-light mb-2 rounded p-3">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <i className="ri-map-pin-line me-2 text-primary"></i>
                          <span>{conn.ip || 'IP inconnue'}</span>
                        </div>
                        <small className="text-muted">{getRelativeTime(conn.date_creation)}</small>
                      </div>
                      {conn.user_agent && (
                        <small className="text-muted d-block mt-2">
                          <i className="ri-computer-line me-1"></i>
                          {conn.user_agent.substring(0, 50)}...
                        </small>
                      )}
                    </div>
                  ))
                ) : (
                  <p className="text-muted text-center">Aucune connexion récente</p>
                )}
              </div>

              <h5 className="section-title mb-4">Statistiques</h5>
              <div className="info-card text-center mb-4">
                <div className="d-flex justify-content-around">
                  <div>
                    <h3 className="fw-bold text-primary mb-1">{stats?.factures || 0}</h3>
                    <small className="text-muted">Factures</small>
                  </div>
                  <div className="vr"></div>
                  <div>
                    <h3 className="fw-bold text-primary mb-1">{stats?.devis || 0}</h3>
                    <small className="text-muted">Devis</small>
                  </div>
                </div>
              </div>

              <h5 className="section-title mb-4">Contact</h5>
              <div className="info-card">
                <ul className="list-unstyled mb-0">
                  <li className="mb-3">
                    <i className="ri-mail-line me-2 text-primary"></i>
                    <span>{user?.email}</span>
                  </li>
                  <li className="mb-3">
                    <i className="ri-calendar-line me-2 text-primary"></i>
                    <span>Membre depuis {formatDate(user?.date_creation)}</span>
                  </li>
                  <li>
                    <i className="ri-time-line me-2 text-primary"></i>
                    <span>Dernière connexion: {user?.derniere_connexion ? formatDate(user.derniere_connexion) : 'N/A'}</span>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </div>
        <Footer />
      </div>

      {/* Modals */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)} centered size="lg">
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold">
            <i className="ri-edit-line me-2 text-primary"></i>
            Modifier le profil
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4">
          {formError && <Alert variant="danger">{formError}</Alert>}
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Nom</Form.Label>
                  <Form.Control
                    type="text"
                    value={editForm.nom_utilisateur}
                    onChange={(e) => setEditForm({...editForm, nom_utilisateur: e.target.value})}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Prénom</Form.Label>
                  <Form.Control
                    type="text"
                    value={editForm.prenom_utilisateur}
                    onChange={(e) => setEditForm({...editForm, prenom_utilisateur: e.target.value})}
                  />
                </Form.Group>
              </Col>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="email"
                    value={editForm.email}
                    onChange={(e) => setEditForm({...editForm, email: e.target.value})}
                  />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button variant="light" onClick={() => setShowEditModal(false)}>Annuler</Button>
          <Button variant="primary" onClick={handleUpdateProfile} disabled={saving}>
            {saving ? <Spinner size="sm" /> : 'Enregistrer'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold">
            <i className="ri-lock-password-line me-2 text-primary"></i>
            Changer le mot de passe
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4">
          {formError && <Alert variant="danger">{formError}</Alert>}
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Ancien mot de passe</Form.Label>
              <Form.Control
                type="password"
                value={passwordForm.ancien_mdp}
                onChange={(e) => setPasswordForm({...passwordForm, ancien_mdp: e.target.value})}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Nouveau mot de passe</Form.Label>
              <Form.Control
                type="password"
                value={passwordForm.nouveau_mdp}
                onChange={(e) => setPasswordForm({...passwordForm, nouveau_mdp: e.target.value})}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Confirmer</Form.Label>
              <Form.Control
                type="password"
                value={passwordForm.confirmation}
                onChange={(e) => setPasswordForm({...passwordForm, confirmation: e.target.value})}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button variant="light" onClick={() => setShowPasswordModal(false)}>Annuler</Button>
          <Button variant="primary" onClick={handleChangePassword} disabled={saving}>
            {saving ? <Spinner size="sm" /> : 'Changer'}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={show2FAModal} onHide={() => {setShow2FAModal(false); setTwoFAPassword(""); setFormError("");}} centered>
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold">
            <i className="ri-shield-keyhole-line me-2 text-primary"></i>
            {twoFAEnabled ? "Désactiver la 2FA" : "Activer la 2FA"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-4">
          {formError && <Alert variant="danger">{formError}</Alert>}
          <div className="text-center py-3">
            <div className="display-1 text-primary mb-4">
              <i className="ri-shield-line"></i>
            </div>
            <h5 className="mb-3">
              {twoFAEnabled ? "Pour désactiver la 2FA" : "Pour activer la 2FA"}
            </h5>
            <Form.Group className="mb-4">
              <Form.Label>Confirmez votre mot de passe</Form.Label>
              <Form.Control
                type="password"
                value={twoFAPassword}
                onChange={(e) => setTwoFAPassword(e.target.value)}
                placeholder="Votre mot de passe"
                size="lg"
              />
            </Form.Group>
            <Alert variant="info" className="text-start">
              <i className="ri-information-line me-2"></i>
              L'authentification à deux facteurs ajoute une couche de sécurité supplémentaire.
            </Alert>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button variant="light" onClick={() => {setShow2FAModal(false); setTwoFAPassword("");}}>Annuler</Button>
          <Button variant="primary" onClick={handleToggle2FA} disabled={twoFALoading || !twoFAPassword}>
            {twoFALoading ? <Spinner size="sm" /> : (twoFAEnabled ? "Désactiver" : "Activer")}
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}